import {useEffect,useRef} from 'react'
import {useBlocker} from 'react-router-dom'

// Data-router blocker covers SPA pushes/replaces and native Back/Forward.
// It only asks to discard unsaved local edits; it never saves, retries or stores
// message content. Auth/session unmount still tears this guard down immediately.
export function useComposerNavigationGuard(dirty){
  const blocker=useBlocker(Boolean(dirty)),handled=useRef(null)
  useEffect(()=>{
    if(blocker.state!=='blocked'){handled.current=null;return}
    if(handled.current===blocker)return
    handled.current=blocker
    if(window.confirm('Discard your unsaved email edits and leave this page? Saved artwork and confirmed draft receipts will remain intact.'))blocker.proceed()
    else blocker.reset()
  },[blocker])
}
